<!-- eslint-disable max-len -->
<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Términos de Uso</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page">
            <section class="section">
                <header class="lcu-section-header lcu-center-text">
                Legacy Christian University - Términos de Uso (Traducción completa al español)
                </header>
            </section>
            <section class="section">
                <p>
                    Por favor revise cuidadosamente estos Términos, ya que constituyen un contrato
                    exigible entre nosotros y contienen información importante sobre sus derechos
                    legales, recursos y obligaciones.
                </p>
                <p>
                    AL ACEPTAR ESTOS TÉRMINOS, USTED ACEPTA RESOLVER TODAS LAS
                    DISPUTAS CON LEGACY CHRISTIAN UNIVERSITY ÚNICAMENTE EN LA CORTE DE
                    RECLAMOS MENORES O MEDIANTE ARBITRAJE INDIVIDUAL VINCULANTE, Y
                    RENUNCIA AL DERECHO DE PARTICIPAR EN DEMANDAS COLECTIVAS Y A QUE
                    LAS RECLAMACIONES SEAN DECIDIDAS POR UN JURADO, TAL COMO SE
                    EXPLICA EN LA SECCIÓN DE RESOLUCIÓN DE DISPUTAS.
                </p>
                <p>
                    Necesitamos reglas para mantener nuestra plataforma y nuestros servicios seguros
                    para usted, para nosotros y para nuestros estudiantes. Estos Términos se aplican
                    a todas sus actividades en el sitio web de Legacy Christian University, nuestras
                    aplicaciones móviles, nuestras APIs y otros servicios relacionados
                    (“Servicios”).
                </p>
                <p>
                    Nuestro sitio web y nuestras aplicaciones hacen que se envíen desde usted
                    a terceros que prestan servicios a Legacy Christian University comunicaciones
                    sobre su navegación, sus actividades en las aplicaciones y el uso de las
                    aplicaciones. Al utilizar
                    nuestros Servicios, usted consiente dichas comunicaciones.
                </p>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">Cuentas</h2>
                <div class="lcu-term-section">
                <p>
                    Usted necesita una cuenta para la mayoría de las actividades en nuestra
                    plataforma,
                    incluyendo comprar y acceder a contenido o enviar contenido para su
                    publicación. Al
                    crear y mantener su cuenta, debe proporcionar y seguir proporcionando
                    información
                    precisa y completa, incluyendo una dirección de correo electrónico válida.
                    Usted tiene
                    plena responsabilidad por su cuenta y por todo lo que suceda en su cuenta,
                    incluyendo cualquier daño o perjuicio (a nosotros o a cualquier otra persona)
                    causado
                    por alguien que use su cuenta sin su permiso. Esto significa que debe tener
                    cuidado
                    con su contraseña. Usted no puede transferir su cuenta a otra persona ni usar
                    la cuenta
                    de otra persona. Si se comunica con nosotros para solicitar acceso a una
                    cuenta, no le
                    otorgaremos dicho acceso a menos que pueda proporcionarnos la información que
                    necesitamos para probar que usted es el propietario de esa cuenta. En caso de
                    fallecimiento de un estudiante, la cuenta de ese estudiante será cerrada.
                    Usted no puede compartir las credenciales de inicio de sesión de su cuenta
                    con nadie
                    más.
                </p>
                <p>
                    Usted es responsable de lo que ocurra con su cuenta y Legacy Christian
                    University no
                    intervendrá en disputas entre estudiantes o instructores que hayan compartido
                    credenciales de inicio de sesión.
                </p>
                <p>
                    Debe notificarnos inmediatamente al enterarse de que otra persona podría estar
                    usando su cuenta sin su permiso (o si sospecha cualquier otro incidente
                    de seguridad)
                    contactando a nuestro Equipo de Soporte. Podemos solicitarle cierta
                    información para
                    confirmar que usted es efectivamente el propietario de su cuenta.
                </p>
                <p>
                    Usted puede cancelar su cuenta en cualquier momento. Consulte nuestra
                    Política de Privacidad para ver qué sucede cuando cancela su cuenta.
                </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">Inscripción a Contenido y Acceso de Por Vida</h2>
                <div class="lcu-term-section">
                <p>
                    Como estudiante, cuando se inscribe en un programa u otro contenido,
                    ya sea gratuito
                    o de pago, usted está obteniendo una licencia de Legacy Christian
                    University para ver
                    el contenido a través de cualquiera de nuestras plataformas y
                    Servicios, y Legacy
                    Christian University es el licenciante registrado. El contenido se le
                    otorga bajo licencia
                    y no se le vende. Esta licencia no le otorga ningún derecho a revender
                    el contenido de
                    ninguna manera (incluyendo compartir información de la cuenta con un comprador o
                    descargar ilegalmente el contenido y compartirlo en sitios de torrents).
                </p>
                <p>
                    En términos legales más completos, Legacy Christian University le otorga (como
                    estudiante) una licencia limitada, no exclusiva e intransferible para
                    acceder y ver el
                    contenido por el cual usted ha pagado todas las tarifas requeridas,
                    únicamente para
                    sus fines personales, no comerciales y educativos a través de los Servicios, de
                    conformidad con estos Términos y cualquier condición o restricción
                    asociada con el
                    contenido o la función particular de nuestros Servicios. Todos los demás
                    usos están
                    expresamente prohibidos. Usted no puede reproducir, redistribuir,
                    transmitir, asignar,
                    vender, difundir, alquilar, compartir, prestar, modificar, adaptar,
                    editar, crear obras
                    derivadas de, sublicenciar, o de otro modo transferir o usar cualquier
                    contenido a
                    menos que le otorguemos permiso explícito para hacerlo mediante un
                    acuerdo escrito
                    firmado por un representante autorizado de Legacy Christian University.
                    Esto también
                    aplica al contenido al que usted pueda acceder a través de cualquiera
                    de nuestras
                    APIs.
                </p>
                <p>
                    Por lo general, otorgamos a nuestros estudiantes una licencia de
                    acceso de por vida
                    cuando se inscriben en un programa u otro contenido.
                    Sin embargo, nos reservamos el derecho de revocar cualquier licencia
                    para acceder y
                    usar cualquier contenido en cualquier momento en el caso de que decidamos o
                    estemos obligados a deshabilitar el acceso al contenido por razones legales o de
                    políticas, por ejemplo, si el programa u otro contenido en el que usted
                    se inscribió es
                    objeto de una reclamación por derechos de autor, o si determinamos que viola
                    nuestras Directrices de Confianza y Seguridad.
                </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">Pagos, Créditos y Reembolsos</h2>
                <div class="lcu-term-section">
                <p>
                    Los precios de nuestros programas en Legacy Christian University son
                    establecidos por
                    nosotros. En algunos casos, el precio de nuestros programas ofrecidos
                    en el sitio web
                    de Legacy Christian University puede no ser exactamente el mismo que el precio
                    ofrecido en nuestras aplicaciones móviles, debido a los sistemas de
                    precios de los
                    proveedores de plataformas móviles y sus políticas relacionadas con
                    la implementación
                    de ventas y promociones.
                </p>
                <p>
                    Ocasionalmente podemos realizar promociones y ventas para nuestros programas,
                    durante las cuales ciertos programas están disponibles a precios con descuento por un
                    período determinado. El precio aplicable al programa será el precio al momento en
                    que usted complete la compra del programa (en el proceso de pago). Cualquier precio
                    ofrecido para un programa en particular también puede ser diferente cuando usted
                    está conectado a su cuenta, en comparación con el precio disponible para estudiantes
                    que no están inscritos o no han iniciado sesión, porque algunas de nuestras
                    promociones están disponibles únicamente para nuevos estudiantes.
                </p>
                <p>
                    Si usted ha iniciado sesión en su cuenta, la moneda indicada que usted ve se basa en
                    su ubicación cuando creó su cuenta. Si usted no ha iniciado sesión en su cuenta, la
                    moneda del precio se basa en el país donde usted se encuentra. No permitimos que
                    los usuarios vean precios en otras monedas.
                </p>
                <p>
                    Si usted es un estudiante ubicado en un país donde el impuesto sobre el uso y las
                    ventas, el impuesto sobre bienes y servicios o el impuesto al valor agregado es
                    aplicable a ventas al consumidor, nosotros somos responsables de recaudar y remitir
                    dicho impuesto a las autoridades fiscales correspondientes. Dependiendo de su
                    ubicación, el precio que usted ve puede incluir dichos impuestos, o el impuesto puede
                    agregarse al momento del pago.
                </p>
                <p>
                    Usted acepta pagar las tarifas por el/los programa(s) que compre, y nos autoriza a
                    cargar dichas tarifas a su tarjeta de débito o crédito o a procesar otros medios de pago
                    (como Boleto, SEPA, débito directo o billetera móvil). Legacy Christian University
                    trabaja con proveedores de servicios de pago para ofrecerle los métodos de pago más
                    convenientes en su país y para mantener segura su información de pago.
                </p>
                <p>
                    Podemos actualizar sus métodos de pago utilizando información proporcionada por
                    nuestros proveedores de servicios de pago. Consulte nuestra Política de Privacidad
                    para más detalles.
                </p>
                <p>
                    Cuando usted realiza una compra, usted acepta no utilizar un método de pago inválido
                    o no autorizado. Si su método de pago falla y aun así obtiene acceso al programa,
                    usted acepta pagarnos las tarifas correspondientes dentro de los 30 días posteriores a
                    la notificación por parte nuestra. Nos reservamos el derecho de deshabilitar el acceso a
                    cualquier programa por el cual no hayamos recibido el pago adecuado.
                    Legacy Christian University o nuestros socios pueden ofrecer a los estudiantes códigos
                    de regalo y promocionales. Ciertos códigos pueden canjearse por créditos de regalo o
                    promocionales aplicados a su cuenta, los cuales luego pueden utilizarse para comprar
                    programas elegibles en nuestra plataforma, sujeto a los términos incluidos con sus
                    códigos. Otros códigos pueden ser canjeables directamente por Servicios o programas
                    específicos.
                </p>
                <p>
                    Estos códigos y créditos, así como cualquier valor promocional vinculado a ellos,
                    pueden expirar si no se usan dentro del período especificado en su cuenta. Los
                    códigos de regalo y promocionales ofrecidos por Legacy Christian University no
                    pueden reembolsarse en efectivo, a menos que se especifique lo contrario en los
                    términos incluidos con sus códigos o según lo exija la ley aplicable. Los códigos de
                    regalo y promocionales ofrecidos por un socio están sujetos a las políticas de
                    reembolso de ese socio. Si usted tiene múltiples montos de crédito guardados, Legacy
                    Christian University puede determinar cuál de sus créditos aplicar a su compra.
                </p>
                <p>
                    <strong>Todas las ventas de programas son finales y no reembolsables.</strong>
                </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">Reglas de Conducta</h2>
                <div class="lcu-term-section">
                <p>
                    Si usted es estudiante, podemos permitirle hacer preguntas a los instructores de un
                    programa u otro contenido en el que esté inscrito, publicar reseñas de contenido o
                    interactuar con el instructor a través de ciertos Servicios.
                </p>
                <p>
                    Para cierto contenido, el instructor puede invitarle a enviar contenido como “tarea” o
                    exámenes. No publique ni envíe nada que no sea suyo.
                </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">Derechos de Legacy Christian University</h2>
                <div class="lcu-term-section">
                <p>
                    Nosotros somos propietarios de la plataforma y los Servicios de Legacy Christian
                    University, incluyendo el sitio web, las aplicaciones y servicios presentes o futuros, y
                    elementos como nuestros logotipos, API, código, contenido y programas creados por
                    nuestro equipo. Usted no puede manipularlos ni usarlos sin autorización.
                </p>
                <p>
                    Todo derecho, título e interés sobre la plataforma y los Servicios de Legacy Christian
                    University, incluyendo nuestro sitio web, nuestras aplicaciones existentes o futuras,
                    nuestras APIs, bases de datos y el contenido que nuestro equipo o socios envían o
                    proporcionan a través de nuestros Servicios, son y permanecerán como propiedad
                    exclusiva de Legacy Christian University y sus licenciantes. Nuestras plataformas y
                    servicios están protegidos por leyes de derechos de autor, marcas registradas y otras
                    leyes tanto de los Estados Unidos como de otros países. Nada le otorga el derecho de
                    usar el nombre de Legacy Christian University ni ninguna de las marcas registradas,
                    logotipos, nombres de dominio u otras características distintivas de marca de Legacy
                    Christian University. Cualquier retroalimentación, comentarios o sugerencias que usted
                    proporcione con respecto a Legacy Christian University o los Servicios son
                    completamente voluntarios y podremos usar dicha retroalimentación, comentarios o
                    sugerencias como consideremos apropiado y sin ninguna obligación hacia usted.
                </p>
                <p>
                    Usted no puede realizar ninguna de las siguientes acciones mientras accede o usa la
                    plataforma y los Servicios de Legacy Christian University:
                </p>
                <ul>
                    <li class="lcu-acc-bullet">
                        acceder, manipular o usar áreas no públicas de la plataforma (incluyendo
                        almacenamiento de contenido), los sistemas informáticos de Legacy Christian
                        University o los sistemas técnicos de entrega de los proveedores de servicios de
                        Legacy Christian University.
                    </li>
                    <li class="lcu-acc-bullet">
                        deshabilitar, interferir o intentar eludir cualquiera de las funciones de la
                        plataforma relacionadas con la seguridad, o sondear, escanear o probar la
                        vulnerabilidad de cualquiera de nuestros sistemas.
                    </li>
                    <li class="lcu-acc-bullet">
                        copiar, modificar, crear una obra derivada de, realizar ingeniería inversa,
                        desensamblar o intentar de otro modo descubrir cualquier código fuente o
                        contenido en la plataforma o Servicios de Legacy Christian University.
                    </li>
                    <li class="lcu-acc-bullet">
                        acceder o buscar, o intentar acceder o buscar nuestra plataforma por cualquier
                        medio (automatizado o de otra manera) distinto de nuestras funcionalidades de
                        búsqueda disponibles actualmente proporcionadas a través de nuestro sitio
                        web, aplicaciones móviles o API (y únicamente conforme a los términos y
                        condiciones de esas APIs). Usted no puede extraer datos (“scrape”), rastrear
                        (“spider”), usar robots o usar otros medios automatizados de cualquier tipo para
                        acceder a los Servicios.
                    </li>
                    <li class="lcu-acc-bullet">
                        usar de cualquier manera los Servicios para enviar información de identificación
                        de origen alterada, engañosa o falsa (como enviar comunicaciones por correo
                        electrónico que falsamente aparenten ser de Legacy Christian University); o
                        interferir o interrumpir (o intentar hacerlo) el acceso de cualquier usuario,
                        anfitrión o red, incluyendo, sin limitación, enviar un virus, sobrecargar, inundar,
                        enviar spam o bombardeo de correo (“mail-bombing”) a las plataformas o
                        servicios, o de cualquier otra manera interferir o crear una carga indebida sobre
                        los Servicios.
                    </li>
                </ul>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">Términos Legales Misceláneos</h2>
                <div class="lcu-term-section">
                <p>
                    <strong>Acuerdo Vinculante</strong>
                </p>
                <p>
                    Usted acepta que al registrarse, acceder o usar nuestros Servicios, usted está
                    aceptando celebrar un contrato legalmente vinculante con Legacy Christian University.
                    Si usted no está de acuerdo con estos Términos, no se registre, no acceda ni use de
                    otra manera ninguno de nuestros Servicios.
                </p>
                <p>
                    Cualquier versión de estos Términos en un idioma distinto del inglés se proporciona
                    por conveniencia y usted entiende y acepta que el idioma inglés controlará en caso de
                    conflicto.
                </p>
                <p>
                    Estos Términos (incluyendo cualquier acuerdo y política vinculados desde estos
                    Términos) constituyen el acuerdo completo entre usted y nosotros.
                </p>
                <p>
                    Si alguna parte de estos Términos se considera inválida o inaplicable conforme a la ley
                    aplicable, entonces dicha disposición se considerará reemplazada por una disposición
                    válida y aplicable que se asemeje lo más posible a la intención de la disposición
                    original, y el resto de estos Términos continuará en vigor.
                </p>
                <p>
                    Incluso si nos retrasamos en ejercer nuestros derechos o dejamos de ejercer un
                    derecho en un caso, ello no significa que renunciemos a nuestros derechos bajo estos
                    Términos, y podemos decidir hacerlos valer en el futuro. Si decidimos renunciar a
                    cualquiera de nuestros derechos en una instancia particular, ello no significa que
                    renunciemos a nuestros derechos en general o en el futuro.
                </p>
                <p>
                    <strong>Exenciones de Responsabilidad</strong>
                </p>
                <p>
                    Puede ocurrir que nuestra plataforma esté fuera de servicio, ya sea por mantenimiento
                    planificado o porque algo falle en el sitio.
                </p>
                <p>
                    También puede ocurrir que enfrentemos problemas de seguridad. Estos son solo
                    ejemplos. Usted acepta que no tendrá ningún recurso contra nosotros en este tipo de
                    casos donde las cosas no salgan bien.
                </p>
                <p>
                    En términos legales más completos, los Servicios, incluyendo cualquier contenido, se
                    proporcionan “tal cual” y “según disponibilidad”. No hacemos declaraciones ni
                    garantías sobre la idoneidad, confiabilidad, disponibilidad, oportunidad, seguridad,
                    ausencia de errores o exactitud de los Servicios, y expresamente renunciamos a toda
                    garantía o condición (expresa o implícita), incluyendo garantías implícitas de
                    comerciabilidad, idoneidad para un propósito particular, título y no infracción.
                </p>
                <p>
                    No garantizamos que usted obtendrá resultados específicos del uso de los Servicios.
                    Su uso de los Servicios (incluyendo cualquier contenido) es completamente bajo su
                    propio riesgo. Algunas jurisdicciones no permiten la exclusión de garantías implícitas,
                    por lo que algunas de las exclusiones anteriores pueden no aplicarse a usted.
                </p>
                <p>
                    Podemos decidir dejar de poner a disposición ciertas funciones de los Servicios en
                    cualquier momento y por cualquier razón. Bajo ninguna circunstancia Legacy Christian
                    University será responsable por daños debido a dichas interrupciones o falta de
                    disponibilidad de tales funciones.
                </p>
                <p>
                    No somos responsables por demoras o fallas en nuestro desempeño de cualquiera de
                    los Servicios causadas por eventos fuera de nuestro control razonable, como un acto
                    de guerra, hostilidad o sabotaje; desastre natural; interrupción eléctrica, de internet o
                    de telecomunicaciones; o restricciones gubernamentales.
                </p>
                <p>
                    <strong>Limitación de Responsabilidad</strong>
                </p>
                <p>
                    En la medida permitida por la ley, no seremos responsables por daños indirectos,
                    incidentales, punitivos o consecuentes (incluyendo pérdida de datos, ingresos,
                    utilidades o oportunidades de negocio, o lesiones personales o muerte), ya sea que
                    surjan de contrato, garantía, agravio, responsabilidad por producto u otra causa,
                    incluso si se nos ha advertido previamente sobre la posibilidad de dichos daños.
                    Nuestra responsabilidad hacia usted o hacia terceros bajo cualquier circunstancia se
                    limita al mayor de USD $100 o la cantidad que usted nos haya pagado en los 12 meses
                    anteriores al evento que dio origen a sus reclamaciones.
                </p>
                <p>
                    Algunas jurisdicciones no permiten la exclusión o limitación de responsabilidad por
                    daños consecuentes o incidentales, por lo que algunas de las limitaciones anteriores
                    pueden no aplicarse a usted.
                </p>
                <p>
                    <strong>Indemnización</strong>
                </p>
                <p>
                    Si usted se comporta de una manera que nos cause problemas legales, podemos
                    ejercer recursos legales contra usted. Usted acepta indemnizar, defender (si así lo
                    solicitamos) y eximir de responsabilidad a Legacy Christian University frente a y contra
                    cualquier reclamación, demanda, pérdida, daño o gasto de terceros (incluyendo
                    honorarios razonables de abogados) que surjan de: (a) el contenido que usted
                    publique o envíe; (b) su uso de los Servicios; (c) su violación de estos Términos; o (d) su
                    violación de cualquier derecho de un tercero. Su obligación de indemnización
                    sobrevivirá a la terminación de estos Términos y a su uso de los Servicios.
                </p>
                <p>
                    <strong>Ley Aplicable y Jurisdicción</strong>
                </p>
                <p>
                    Cuando estos Términos mencionan “Legacy Christian University”, se refieren a la
                    entidad de Legacy Christian University con la que usted está contratando. Si usted es
                    estudiante, su entidad contratante y la ley aplicable generalmente se determinarán
                    según su ubicación.
                </p>
                <p>
                    Si usted accede a nuestros Servicios a través de una de nuestras aplicaciones móviles
                    (como nuestra aplicación Android o iOS) y el pago se procesa a través del sistema de
                    pago de un proveedor de plataforma móvil, usted está contratando con Legacy
                    Christian University y estos Términos se rigen por las leyes del Estado de California, EE.
                    UU., sin referencia a sus principios de elección de ley o conflicto de leyes. En los casos
                    en que la sección de “Resolución de Disputas” a continuación no se aplique a usted,
                    usted consiente la jurisdicción y competencia exclusivas de los tribunales estatales y
                    federales en California, EE. UU.
                </p>
                <p>
                    <strong>Acciones Legales y Notificaciones</strong>
                </p>
                <p>
                    Ninguna acción, sin importar su forma, derivada de o relacionada con este Acuerdo
                    podrá ser presentada por cualquiera de las partes después de transcurrido más de un
                    año desde que la causa de acción haya surgido, salvo cuando esta limitación no pueda
                    imponerse por ley.
                </p>
                <p>
                    Cualquier notificación u otra comunicación que deba darse conforme a este
                    documento será por escrito y se entregará mediante correo registrado o certificado
                    con acuse de recibo, o por correo electrónico (por nosotros al correo asociado con su
                    cuenta o por usted a nosotros).
                </p>
                <p>
                    <strong>Relación entre las Partes</strong>
                </p>
                <p>
                    Usted y nosotros acordamos que no existe entre nosotros ninguna relación de empresa
                    conjunta, sociedad, empleo, contratación independiente o agencia.
                </p>
                <p>
                    <strong>No Cesión</strong>
                </p>
                <p>
                    Usted no puede ceder ni transferir estos Términos (o los derechos y licencias otorgados
                    bajo ellos). Por ejemplo, si registró una cuenta como empleado de una empresa, su
                    cuenta no puede transferirse a otro empleado. Nosotros можем (podemos) ceder
                    estos Términos (o los derechos y licencias otorgados bajo ellos) a otra empresa o
                    persona sin restricción. Nada en estos Términos confiere ningún derecho, beneficio o
                    recurso a ninguna persona o entidad tercera. Usted acepta que su cuenta es
                    intransferible y que todos los derechos sobre su cuenta y otros derechos bajo estos
                    Términos terminan con su fallecimiento.
                </p>
                <p>
                    <strong>Sanciones y Leyes de Exportación</strong>
                </p>
                <p>
                    Usted garantiza que usted (como individuo o como representante de cualquier entidad
                    en cuyo nombre use los Servicios) no se encuentra ubicado ni reside en ningún país
                    sujeto a sanciones comerciales o embargos aplicables de los EE. UU. (como Cuba, Irán,
                    Corea del Norte, Siria o las regiones de Crimea, Donetsk o Luhansk). Usted también
                    garantiza que no es una persona o entidad nombrada en ninguna lista gubernamental
                    de EE. UU. de nacionales especialmente designados o de partes denegadas.
                    Si usted llega a estar sujeto a tal restricción durante la vigencia de cualquier acuerdo
                    con Legacy Christian University, usted nos notificará dentro de las 24 horas, y nosotros
                    tendremos el derecho de terminar cualquier obligación adicional hacia usted, con
                    efecto inmediato y sin ninguna responsabilidad adicional hacia usted (sin perjuicio de
                    sus obligaciones pendientes con Legacy Christian University).
                </p>
                <p>
                    Usted no puede acceder, usar, exportar, reexportar, desviar, transferir o divulgar
                    ninguna parte de los Servicios ni cualquier información técnica o material relacionado,
                    directa o indirectamente, en violación de cualquier ley, regla o regulación de control de
                    exportaciones y sanciones comerciales de los EE. UU. y de otros países aplicables.
                </p>
                <p>
                    Usted acepta no cargar ni poner a disposición ningún contenido, tecnología o
                    información (incluyendo información sobre cifrado) cuya exportación esté
                    específicamente controlada bajo dichas leyes.
                </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">Resolución de Disputas</h2>
                <div class="lcu-term-section">
                <p>
                    Esta sección de Resolución de Disputas (“Acuerdo de Resolución de Disputas”) aplica
                    solo si usted vive en los Estados Unidos o Canadá. La mayoría de las disputas pueden
                    resolverse, así que antes de presentar un caso legal formal, por favor primero intente
                    contactar a nuestro Equipo de Soporte.
                </p>
                <p>
                    <strong>Descripción General de la Resolución de Disputas</strong>
                </p>
                <p>
                    Legacy Christian University se compromete a usar sus mejores esfuerzos para resolver
                    disputas con sus usuarios sin necesidad de presentar una reclamación legal formal. Si
                    surge un problema entre nosotros, usted y Legacy Christian University acuerdan
                    primero trabajar diligentemente y de buena fe para alcanzar una resolución justa y
                    equitativa para ambas partes utilizando el proceso obligatorio de resolución informal
                    descrito a continuación. En ocasiones, puede ser necesario un tercero para ayudar a
                    resolver la disputa. Este Acuerdo de Resolución de Disputas limita cómo pueden
                    resolverse estas disputas.
                </p>
                <p>
                    USTED Y LEGACY CHRISTIAN UNIVERSITY ACEPTAN QUE TODAS Y CADA UNA
                    DE LAS DISPUTAS, RECLAMACIONES O CONTROVERSIAS QUE SURJAN DE O SE
                    RELACIONEN CON ESTOS TÉRMINOS O CON SU APLICABILIDAD,
                    INCUMPLIMIENTO, TERMINACIÓN, VALIDEZ, EJECUCIÓN O INTERPRETACIÓN, O
                    CON EL USO DE LOS SERVICIOS O LAS COMUNICACIONES CON LEGACY
                    CHRISTIAN UNIVERSITY (COLECTIVAMENTE, “DISPUTAS”) QUE NO SE
                    RESUELVAN INFORMALMENTE DEBEN SER TRATADAS ÚNICAMENTE EN LA
                    CORTE DE RECLAMOS MENORES O MEDIANTE ARBITRAJE INDIVIDUAL
                    VINCULANTE, Y ACEPTAN RENUNCIAR AL DERECHO A JUICIO POR JURADO Y A
                    PRESENTAR UN CASO EN CUALQUIER OTRO TRIBUNAL.
                </p>
                <p>
                    USTED Y LEGACY CHRISTIAN UNIVERSITY TAMBIÉN ACEPTAN PRESENTAR
                    RECLAMOS EN CONTRA DEL OTRO SOLO EN CAPACIDAD INDIVIDUAL, Y NO
                    COMO DEMANDANTE O MIEMBRO DE UNA DEMANDA COLECTIVA O
                    PROCEDIMIENTO REPRESENTATIVO, YA SEA EN TRIBUNAL O EN ARBITRAJE.
                </p>
                <p>
                    Usted y Legacy Christian University aceptan que este Acuerdo de Resolución de
                    Disputas aplica a cada uno de nosotros, así como a todos nuestros respectivos
                    agentes, abogados, contratistas, subcontratistas, proveedores de servicios, empleados
                    y todos los demás que actúen para o en nombre de usted y Legacy Christian
                    University. Este Acuerdo de Resolución de Disputas es vinculante para sus herederos,
                    sucesores y cesionarios respectivos, y se rige por la Ley Federal de Arbitraje (Federal
                    Arbitration Act).
                </p>
                <p>
                    <strong>Proceso Obligatorio de Resolución Informal de Disputas</strong>
                </p>
                <p>
                    Antes de presentar una reclamación el uno contra el otro, usted y Legacy Christian
                    University deben primero participar en el proceso de resolución informal descrito en
                    esta sección.
                </p>
                <ul>
                    <li class="lcu-acc-bullet">
                    La parte reclamante enviará a la otra una breve declaración por escrito (“Declaración
                    de Reclamación” o “Claim Statement”) con su nombre completo, dirección postal y
                    dirección de correo electrónico explicando: (a) la naturaleza y los detalles de la
                    Disputa; y (b) una propuesta para resolverla (incluyendo cualquier monto de dinero
                    reclamado y cómo se calculó dicho monto). Enviar una Declaración de Reclamación
                    suspende el cómputo de cualquier plazo de prescripción aplicable por un período de
                    60 días que comienza en la fecha en que se recibe la Declaración de Reclamación.
                    Usted debe enviar su Declaración de Reclamación a Legacy Christian University por
                    correo electrónico, y también puede enviarla por correo certificado. Legacy Christian
                    University enviará Declaraciones de Reclamación y le responderá a la dirección de
                    correo electrónico asociada con su cuenta de Legacy Christian University, a menos que
                    usted solicite lo contrario.
                    </li>
                    <li class="lcu-acc-bullet">
                    Cuando cualquiera de nosotros reciba una Declaración de Reclamación, las partes
                    intentarán de buena fe resolverla informalmente. Si no podemos resolverla dentro de
                    los 60 días desde su recepción, entonces cada uno de nosotros tiene el derecho de
                    iniciar una reclamación formal contra el otro en la corte de reclamos menores o en
                    arbitraje individual, sujeto a los términos de este Acuerdo de Resolución de Disputas.
                    </li>
                </ul>
                <p>
                    No completar este proceso constituye un incumplimiento material de los Términos, y
                    ningún tribunal ni árbitro tendrá jurisdicción para conocer o resolver ninguna Disputa
                    entre usted y Legacy Christian University.
                </p>
                <p>
                    <strong>Corte de Reclamos Menores</strong>
                </p>
                <p>
                    Las Disputas planteadas pero no resueltas mediante el proceso obligatorio de
                    resolución informal pueden presentarse en la corte de reclamos menores en: (a)
                    California; (b) el condado donde usted vive; o (c) otro lugar que ambos acordemos.
                    Cada uno de nosotros renuncia al derecho de presentar cualquier Disputa entre
                    nosotros en tribunales distintos a la corte de reclamos menores, incluyendo tribunales
                    de jurisdicción general o especial.
                </p>
                <p>
                    <strong>Arbitraje</strong>
                </p>
                <p>
                    Como única alternativa a la corte de reclamos menores, usted y Legacy Christian
                    University tienen el derecho de resolver Disputas mediante arbitraje individual. Aunque
                    no hay juez ni jurado en un arbitraje, el árbitro tiene el poder de otorgar el mismo tipo
                    de reparación individual y debe seguir nuestro acuerdo del mismo modo que un
                    tribunal. Si uno de nosotros lleva una Disputa a un tribunal que no sea la corte de
                    reclamos menores, la otra parte puede pedir al tribunal que nos obligue a ambos a ir a
                    arbitraje. Cualquiera de nosotros también puede pedir a un tribunal que suspenda un
                    procedimiento judicial mientras un arbitraje esté en curso. En la medida en que alguna
                    causa de acción o reclamo de reparación no pueda tratarse en arbitraje, usted y
                    Legacy Christian University acuerdan que todos los procedimientos judiciales se
                    pausarán hasta la resolución en arbitraje de todas las causas y reclamaciones
                    arbitrables. Nada en este Acuerdo de Resolución de Disputas pretende limitar la
                    reparación individual disponible para cualquiera de nosotros en arbitraje o en la corte
                    de reclamos menores.
                </p>
                <p>
                    Si usted y Legacy Christian University no están de acuerdo sobre si una Disputa debe
                    someterse a arbitraje, el alcance de los poderes del árbitro o la exigibilidad de
                    cualquier aspecto de este Acuerdo de Resolución de Disputas, el árbitro por sí solo
                    tendrá, en la máxima medida permitida por la ley, la autoridad exclusiva para abordar
                    todos esos desacuerdos, incluyendo, entre otros, los relacionados con la formación,
                    legalidad, interpretación y exigibilidad de este Acuerdo de Resolución de Disputas.
                    Esta disposición no limita el procedimiento para impugnar un arbitraje iniciado de
                    forma impropia.
                </p>
                <p>
                    Cualquier tribunal competente tendrá autoridad para hacer cumplir los requisitos de
                    este Acuerdo de Resolución de Disputas y, si es necesario, impedir (mediante orden
                    judicial) la presentación o prosecución de arbitrajes, y la imposición de tarifas por
                    cualquier arbitraje o mediación que no se lleve a cabo bajo este Acuerdo de
                    Resolución de Disputas.
                </p>
                <p>
                    Si la American Arbitration Association (“AAA”) o cualquier otra organización de
                    arbitraje o árbitro, por cualquier motivo, no puede administrar un arbitraje requerido
                    bajo este Acuerdo de Resolución de Disputas, usted y Legacy Christian University
                    negociarán de buena fe la sustitución de otra organización o individuo para manejar el
                    arbitraje. Si no podemos acordar una alternativa, usted o Legacy Christian University
                    pueden solicitar a un tribunal competente que nombre una organización o individuo
                    para conducir el arbitraje de manera consistente con este Acuerdo de Resolución de
                    Disputas y a un costo comparable al de la organización designada.
                </p>
                <p>
                    <strong>Reglas Generales de Arbitraje</strong>
                </p>
                <p>
                    El proceso de arbitraje diferirá dependiendo de si su reclamación se persigue
                    individualmente o como parte de un Arbitraje Masivo (definido a continuación). Las
                    reglas generales de arbitraje descritas en esta sección (“Reglas Generales de
                    Arbitraje”) controlarán, excepto en el caso de un Arbitraje Masivo.
                </p>
                <p>
                    Todos los arbitrajes serán ante un solo árbitro. Salvo disposición contraria en este
                    Acuerdo de Resolución de Disputas, una parte que elija arbitraje debe iniciar el
                    procedimiento presentando una demanda de arbitraje ante la AAA. Los arbitrajes que
                    involucren consumidores se regirán por estos Términos y por las Reglas de Arbitraje de
                    <a href="https://www.adr.org/consumer" rel="noopener noreferrer" target="_blank" class="lcu-term-link">
                        Consumidores de la AAA y el Protocolo de Debido Proceso del Consumidor de la AAA
                    </a>. Los arbitrajes que involucren a todos los demás, incluyendo instructores, se
                    regirán por estos Términos y por las Reglas de
                    <a href="https://www.adr.org/commercial" rel="noopener noreferrer" target="_blank" class="lcu-term-link">
                        Arbitraje Comercial de la AAA y las Reglas Opcionales de Apelación de la AAA
                    </a>. Si hay conflicto entre estos Términos y
                    cualquier regla o protocolo aplicable de la AAA, estos Términos prevalecerán.
                    Las Disputas que involucren una reclamación de menos de USD $15,000 en daños
                    reales o estatutarios (sin incluir honorarios de abogados ni daños incidentales,
                    consecuentes, punitivos o ejemplares, ni multiplicadores de daños) deben resolverse
                    exclusivamente mediante arbitraje individual vinculante sin comparecencia, basado
                    únicamente en presentaciones escritas de las partes.
                </p>
                <p>
                    Todos los demás arbitrajes se llevarán a cabo por teléfono, videoconferencia o basados
                    solo en presentaciones escritas. El fallo sobre la decisión del árbitro puede registrarse
                    en cualquier tribunal que tenga jurisdicción para ello.
                </p>
                <p>
                    Para iniciar un procedimiento de arbitraje con la AAA, la parte reclamante debe enviar
                    una carta describiendo la Disputa y solicitando arbitraje a: American Arbitration
                    Association Case Filing Services, 1101 Laurel Oak Road, Suite 100, Voorhees, NJ
                    08043, o presentando una solicitud en línea a través del
                    <a href="https://www.adr.org/Support" rel="noopener noreferrer" target="_blank" class="lcu-term-link">
                        sitio web de la AAA
                    </a>.
                </p>
                <p>
                    <strong>Reglas de Arbitraje Masivo</strong>
                </p>
                <p>
                    Si 25 o más reclamantes (cada uno un “reclamante de Arbitraje Masivo”) o sus
                    abogados presentan o divulgan la intención de presentar demandas de arbitraje contra
                    Legacy Christian University planteando Disputas sustancialmente idénticas, y el
                    abogado de los reclamantes es el mismo o está coordinado entre las Disputas (un
                    “Arbitraje Masivo”), se aplicarán estas reglas especiales.
                </p>
                <p>
                    Cada reclamante de Arbitraje Masivo debe completar el proceso de resolución
                    informal descrito en este Acuerdo de Resolución de Disputas. El abogado de los
                    reclamantes presentará una sola Declaración de Reclamación para todos los
                    reclamantes del Arbitraje Masivo que identifique a todos los reclamantes del Arbitraje
                    Masivo por nombre completo, dirección postal y dirección de correo electrónico.
                    Luego, los reclamantes del Arbitraje Masivo deberán seguir un “procedimiento
                    bellwether” descrito a continuación, en el cual un grupo de hasta 10 reclamantes
                    procederá a arbitraje (cada uno un “arbitraje bellwether”), seguido de un proceso
                    obligatorio de mediación mediante el cual pueden resolverse las Disputas de los
                    reclamantes del Arbitraje Masivo. Cualquier plazo de prescripción aplicable a las
                    Disputas de los reclamantes del Arbitraje Masivo quedará suspendido desde la
                    presentación de su Declaración de Reclamación hasta que se haya completado el
                    proceso obligatorio de mediación.
                </p>
                <p>
                    El abogado de los reclamantes del Arbitraje Masivo y el abogado de Legacy Christian
                    University seleccionarán cada uno hasta cinco reclamantes para arbitrajes bellwether
                    (no más de 10 en total) para que cada uno sea decidido prontamente e
                    individualmente como un arbitraje bellwether conducido bajo las Reglas Generales de
                    Arbitraje, asignándose cada caso a un árbitro diferente. Si otros reclamantes del
                    Arbitraje Masivo han presentado reclamaciones en arbitraje, dichas reclamaciones
                    deberán ser desestimadas prontamente sin perjuicio antes de que los arbitrajes
                    bellwether puedan proceder. Cada arbitraje bellwether deberá completarse dentro de
                    120 días. No podrán iniciarse otras demandas de arbitraje por reclamantes del
                    Arbitraje Masivo durante la pendencia de los arbitrajes bellwether y el proceso
                    obligatorio de mediación posterior.
                </p>
                <p>
                    Una vez resueltos los 10 casos bellwether, el abogado de Legacy Christian University y
                    el abogado de los reclamantes del Arbitraje Masivo participarán prontamente y de
                    buena fe en una mediación confidencial no vinculante por un período de al menos 60
                    días, en un esfuerzo de buena fe para resolver todas las Disputas de los reclamantes
                    del Arbitraje Masivo. Esta mediación será conducida por la AAA bajo sus
                    Procedimientos de Mediación vigentes en ese momento, a menos que Legacy
                    Christian University y los reclamantes del Arbitraje Masivo acuerden mutuamente otro
                    mediador y/o procedimiento de mediación.
                </p>
                <p>
                    Si los arbitrajes bellwether y la mediación posterior no logran resolver las Disputas de
                    todos los reclamantes del Arbitraje Masivo, entonces aquellos reclamantes del
                    Arbitraje Masivo cuyas Disputas no hayan sido resueltas solo podrán perseguir dichas
                    Disputas de manera individual en la corte de reclamos menores o con FairClaims, Inc.
                    (“FairClaims”), y no ante la AAA ni ante ninguna otra organización arbitral o árbitro,
                    bajo las
                    <a href="https://www.fairclaims.com/"  rel="noopener noreferrer" target="_blank" class="lcu-term-link">
                        Reglas y Procedimientos de Reclamos Menores de FairClaims
                    </a>. En la medida en
                    que alguna causa de acción o reclamo de reparación no pueda ser tratado por
                    FairClaims bajo sus Reglas y Procedimientos de Reclamos Menores, usted y Legacy
                    Christian University acuerdan que cualquier procedimiento judicial que involucre a
                    reclamantes del Arbitraje Masivo y a Legacy Christian University será suspendido hasta
                    la resolución final en arbitraje con FairClaims de todas las causas y reclamaciones
                    arbitrables.
                </p>
                <p>
                    Si las Reglas de Arbitraje Masivo se determinan inexigibles por cualquier razón en una
                    decisión de cualquier árbitro o tribunal respecto de la cual ya no proceda revisión
                    adicional y se hayan resuelto completamente todas las mociones, apelaciones y
                    solicitudes de revisión (una “Determinación Final”), entonces usted y Legacy Christian
                    University acuerdan que todas las Disputas no resueltas entre los reclamantes del
                    Arbitraje Masivo y Legacy Christian University deben presentarse y resolverse
                    únicamente por un tribunal competente (incluyendo, en su caso, en forma de demanda
                    colectiva si la Disputa califica), y no se presentarán, perseguirán ni resolverán mediante
                    arbitraje ni estarán sujetas a ninguna obligación contractual de arbitrar. En la medida
                    en que cualquier arbitraje presentado por o en nombre de reclamantes del Arbitraje
                    Masivo siga pendiente después de una Determinación Final, dichos reclamantes
                    deberán desestimar inmediatamente esos arbitrajes sin perjuicio.
                    Un hallazgo de que estas Reglas de Arbitraje Masivo son inexigibles por cualquier
                    razón, incluyendo cualquier Determinación Final, no afectará la validez o exigibilidad
                    de ninguna otra disposición de estos Términos, incluyendo las establecidas en este
                    Acuerdo de Resolución de Disputas.
                </p>
                <p>
                    <strong>Tarifas y Costos</strong>
                </p>
                <p>
                    Usted y Legacy Christian University acuerdan que cada parte asumirá sus propios
                    costos y honorarios de abogados en caso de una disputa; sin embargo, cualquiera de
                    las partes puede recuperar tarifas y costos en la medida permitida por la ley aplicable.
                    Si un tribunal o árbitro determina que un arbitraje ha sido presentado o amenazado de
                    mala fe, o que la demanda fue frívola o afirmada con un propósito indebido, el tribunal
                    o árbitro puede, en la máxima medida permitida por la ley, otorgar honorarios de
                    abogados a la parte que defiende contra la reclamación, tal como lo haría un tribunal.
                </p>
                <p>
                    <strong>Sin Demandas Colectivas</strong>
                </p>
                <p>
                    Salvo lo expresamente previsto en relación con las Reglas de Arbitraje Masivo, ambos
                    acordamos que cada uno solo puede presentar reclamaciones contra el otro en forma
                    individual. Esto significa: (a) ninguno de nosotros puede presentar una reclamación
                    como demandante o miembro de una demanda colectiva en una acción colectiva,
                    acción consolidada o acción representativa; (b) un árbitro no puede combinar múltiples
                    reclamaciones de diferentes personas en un solo caso (ni presidir ninguna acción
                    consolidada, colectiva o representativa); y (c) la decisión o laudo del árbitro en el caso
                    de un reclamante solo puede decidir las disputas de ese usuario, no las de otros
                    usuarios. Nada en este Acuerdo de Resolución de Disputas limita el derecho de las
                    partes a resolver una Disputa por acuerdo mutuo mediante un acuerdo de conciliación
                    a nivel colectivo.
                </p>
                <p>
                    <strong>Cambios</strong>
                </p>
                <p>
                    No obstante la sección “Actualización de estos Términos” a continuación, si Legacy
                    Christian University cambia esta sección de “Resolución de Disputas” después de la
                    fecha en que usted indicó por última vez su aceptación de estos Términos, usted
                    puede rechazar cualquier cambio proporcionando a Legacy Christian University una
                    notificación por escrito de dicho rechazo por correo o entrega en mano a Legacy
                    Christian University, o por correo electrónico desde la dirección asociada con su cuenta
                    de Legacy Christian University, dentro de los 30 días posteriores a la fecha en que
                    dicho cambio entró en vigor, según lo indicado por el texto “última actualización”
                    anterior.
                    Para que sea efectiva, la notificación debe incluir su nombre completo e indicar
                    claramente su intención de rechazar cambios a esta sección de “Resolución de
                    Disputas”. Al rechazar los cambios, usted acepta que arbitrarán cualquier disputa entre
                    usted y Legacy Christian University conforme a las disposiciones de esta sección de
                    “Resolución de Disputas” vigentes a la fecha en que usted indicó por última vez su
                    aceptación de estos Términos.
                </p>
                <p>
                    <strong>Arbitraje Iniciado de Forma Improcedente</strong>
                </p>
                <p>
                    Si cualquiera de las partes cree que la otra ha iniciado un arbitraje en violación de este
                    Acuerdo de Resolución de Disputas, si tal arbitraje es amenazado o si cualquiera de las
                    partes tiene razón para creer que un arbitraje iniciado de forma improcedente es
                    inminente, la parte contra la cual el arbitraje ha sido o será iniciado puede solicitar una
                    orden de un tribunal competente que impida que el arbitraje sea presentado o
                    continuado, y que otorgue sus tarifas y costos, incluyendo honorarios razonables de
                    abogados incurridos en relación con la solicitud de dicha orden.
                </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">Actualización de estos Términos (pg)</h2>
                <div class="lcu-term-section">
                    <p>
                        De vez en cuando, podemos actualizar estos Términos para aclarar nuestras prácticas o
                        reflejar prácticas nuevas o diferentes (por ejemplo, cuando agregamos nuevas
                        funciones), y Legacy Christian University se reserva el derecho, a su sola discreción, de
                        modificar y/o realizar cambios a estos Términos en cualquier momento. Si realizamos
                        un cambio material, se lo notificaremos mediante medios notorios, tales como
                        notificación por correo electrónico enviada a la dirección de correo especificada en su
                        cuenta o publicando un aviso a través de nuestros Servicios. Las modificaciones
                        entrarán en vigor el día en que se publiquen, a menos que se indique lo contrario.
                    </p>
                    <p>
                        Su uso continuado de nuestros Servicios después de que los cambios entren en vigor
                        significará que usted acepta dichos cambios. Cualquier Término revisado reemplazará
                        a todos los Términos anteriores.
                    </p>
                </div>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';

export default {
  name: 'terms-of-use-page',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    SecondaryNav,
    Footer,
    MobileControls,
    IphoneBar,
  },
};
</script>

<style scoped lang="scss">
.lcu-acc-bullet {
  margin-bottom: 15px;
}

.lcu-term-header {
  font-size: 18px;
  font-weight: bold;
}

.lcu-term-section {
  padding-left: 25px;

  @media only screen and (max-width: $mobile-max) {
   padding-left: 0;
  }
}

.lcu-term-link {
  text-decoration: underline;
  color: $legacy-secondary;

  &:hover {
    text-decoration: none;
  }
}
</style>
